function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/web.dom-collections.iterator.js";
import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Flex } from '@finect/tabular-core/Flex';
import { Menu } from '@finect/tabular-icons/menu';
import { Heart } from '@finect/tabular-icons/heart';
import { HelpCircle } from '@finect/tabular-icons/helpCircle';
import { FinectLogo } from '@finect/tabular-components/FinectLogo';
import { enableBodyScroll, disableBodyScroll, clearAllBodyScrollLocks } from '@finect/tabular-utils/bodyScrollLock';
import { DatalayerStateless } from '@finect/front-gtm';
import { baseURL } from '@finect/front-utils/baseURL';
import { getLoginBaseURL } from '@finect/front-utils/getLoginBaseURL';
import { debounce } from '@finect/front-utils/debounce';
import { IconAction, IconActionText } from './partials/IconAction';
import { UserAction } from './components/UserAction';
import { OmniSearch } from './Search/OmniSearch';
import { AccessButton } from './partials/AccessButton';
import { Separator } from './partials/Separator';
import { OmniNavBlock, MainNav, MainNavContainer } from './partials/OmniNavBlock';
import { MobileMenu } from './MobileMenu';
import { getUser, getTags, getProductFamilies, getBanks } from './actions';
import { NavMenu } from './NavMenu';
import { TAGS_FETCH_QTY } from './config';
import { Logo, NavMenuAction, LinksBar } from './partials/partials';
import { Portal } from './Portal/PortalNew';
import { TextMenu } from './components';
import { DesktopNav } from './partials';
import { getBlobAction } from './utils';
import { menu, newFamiliesLinks } from './data';
const fetchData = function (cookie) {
  let entities = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['user', 'tags', 'productFamilies'];
  return Promise.all([entities.includes('user') ? getUser(cookie) : Promise.resolve(null), entities.includes('tags') ? getTags(TAGS_FETCH_QTY, cookie) : Promise.resolve(null), entities.includes('productFamilies') ? getProductFamilies() : Promise.resolve(null), entities.includes('banks') ? getBanks() : Promise.resolve(null)].map(promise => promise.catch(() => null)));
};
const onRevealChange = state => {
  const event = new CustomEvent('OmniNavStateChanged', {
    detail: state
  });
  window.dispatchEvent(event);
};
const getUserFromProps = props => {
  if (props.user) return props.user;
  if (typeof window === 'undefined') return props.omniNavData ? props.omniNavData.user : null;
  return window.OMNINAV_DATA ? window.OMNINAV_DATA.user : null;
};
const getInitialStateParam = (props, param, emptyValue) => typeof window === 'undefined' ? props.omniNavData && props.omniNavData[param] || emptyValue : window.OMNINAV_DATA && window.OMNINAV_DATA[param] || emptyValue;
export class OmniNav extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "prevScroll", void 0);
    _defineProperty(this, "target", void 0);
    _defineProperty(this, "navMenuTarget", React.createRef());
    _defineProperty(this, "state", {
      reveal: true,
      showMobileNav: false,
      showNavMenu: false,
      showPortal: false,
      user: getUserFromProps(this.props),
      productFamilies: getInitialStateParam(this.props, 'productFamilies', []),
      banks: getInitialStateParam(this.props, 'banks', []),
      tags: getInitialStateParam(this.props, 'tags', null)
    });
    _defineProperty(this, "toggleMobileMenu", () => {
      if (this.state.showMobileNav) {
        clearAllBodyScrollLocks();
      } else {
        disableBodyScroll(this.target);
      }
      this.setState(state => ({
        showMobileNav: !state.showMobileNav
      }));
    });
    _defineProperty(this, "toggleNavMenu", () => {
      if (this.state.showNavMenu) {
        enableBodyScroll(this.navMenuTarget);
      } else {
        disableBodyScroll(this.navMenuTarget);
      }
      this.setState(state => ({
        showNavMenu: !state.showNavMenu
      }));
    });
    _defineProperty(this, "togglePortal", () => {
      this.setState(state => ({
        showPortal: !state.showPortal
      }));
    });
    _defineProperty(this, "debouncedTogglePortal", debounce(this.togglePortal, 20, true));
    _defineProperty(this, "handleScroll", () => {
      const {
        reveal
      } = this.state;
      const scrollDown = this.prevScroll < window.pageYOffset;
      this.prevScroll = window.pageYOffset;
      if (scrollDown) {
        if (reveal && window.pageYOffset >= 105) {
          onRevealChange('closed');
          this.setState({
            reveal: false,
            showPortal: false
          });
        }
        return;
      }
      if (!reveal) {
        onRevealChange('opened');
        this.setState({
          reveal: true
        });
      }
    });
    _defineProperty(this, "setReveal", () => {
      const {
        reveal
      } = this.state;
      if (!reveal) {
        this.setState({
          reveal: true
        });
        onRevealChange('opened');
      }
    });
    _defineProperty(this, "processMessage", event => {
      if (event.data.status === 'loggedIn' && !this.props.user) {
        OmniNav.loadInitialData(undefined, true).then(data => {
          this.setState(data);
        });
      }
    });
  }
  componentDidMount() {
    this.prevScroll = 0;
    document.addEventListener('scroll', this.handleScroll);
    window.addEventListener('message', this.processMessage);
    const hasUserViaProps = this.props.hasOwnProperty('user');
    if (!window.OMNINAV_DATA) {
      OmniNav.loadInitialData(undefined, !hasUserViaProps).then(data => {
        this.setState(state => !hasUserViaProps ? _objectSpread(_objectSpread({}, state), data) : _objectSpread(_objectSpread({}, data), {
          user: this.props.user
        }));
      });
    }
  }
  static getDerivedStateFromProps(props, state) {
    if (!props.user) return null;
    if (props.user.isLoggedIn !== state.user.isLoggedIn) return {
      user: props.user
    };
    return null;
  }
  static loadInitialData(cookie, loadUser) {
    const entities = ['tags', 'productFamilies', ...(loadUser ? ['user'] : [])];
    return fetchData(cookie, entities).then(results => {
      const [user, tags, productFamilies, banks] = results;
      const roleAdviser = user && user.organizations.filter(organization => organization.roles.includes('adviser'));
      return {
        user: user ? _objectSpread(_objectSpread({}, user), {
          isAdviser: Boolean(roleAdviser && roleAdviser.length),
          isLoggedIn: true
        }) : {
          isLoggedIn: false
        },
        tags,
        productFamilies,
        banks
      };
    });
  }
  componentWillUnmount() {
    document.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('message', this.processMessage);
  }
  render() {
    const {
      reveal,
      showMobileNav,
      showNavMenu,
      productFamilies,
      banks,
      tags,
      user
    } = this.state;
    const {
      finectApp = '',
      fullWidth = false,
      withShadow = false
    } = this.props;
    const {
      isLoggedIn
    } = user || {};
    const logoProps = ['front-products'].includes(finectApp) ? {
      as: Link,
      to: '/'
    } : {
      as: 'a',
      href: '/'
    };
    const loginUrl = "".concat(getLoginBaseURL(), "/signup").concat(typeof window !== 'undefined' ? "?action=".concat(getBlobAction({
      next: "https://".concat(baseURL, "/onboarding?next=").concat(window.location.href)
    })) : '');
    return React.createElement(Fragment, null, user ? React.createElement(DatalayerStateless, {
      id: "User",
      type: "user",
      params: {
        user: _objectSpread(_objectSpread({}, user), {
          loggedIn: user.isLoggedIn
        })
      }
    }) : null, React.createElement(NavMenu, {
      show: showNavMenu,
      finectApp: finectApp,
      blocks: menu[0].children,
      productFamilies: productFamilies || [],
      links: newFamiliesLinks || [],
      banks: banks || [],
      storefronts: tags || [],
      onClose: this.toggleNavMenu,
      menuRef: el => this.navMenuTarget = el
    }), React.createElement(OmniNavBlock, {
      reveal: reveal,
      withShadow: withShadow
    }, React.createElement(MainNav, {
      onMouseEnter: this.setReveal
    }, React.createElement(MainNavContainer, {
      fullWidth: fullWidth
    }, React.createElement(Flex, {
      align: "center"
    }, React.createElement(NavMenuAction, {
      onClick: this.toggleNavMenu,
      role: "button"
    }, React.createElement(Menu, {
      color: "#fff",
      strokeWidth: "2",
      size: "20"
    })), React.createElement(Logo, _extends({
      "data-fi-event": "omninav-logo",
      title: "Invertir con Finect"
    }, logoProps), React.createElement(FinectLogo, {
      color: "#fff"
    }))), React.createElement(DesktopNav, null, menu.map((item, index) => React.createElement(TextMenu, _extends({
      key: index,
      finectApp: finectApp,
      app: item.app,
      text: item.title
    }, item.hasOwnProperty('children') ? {
      onAction: !this.state.showPortal ? this.debouncedTogglePortal : () => {}
    } : {}, item.link && !item.hasOwnProperty('children') ? {
      href: item.link
    } : {})))), React.createElement(OmniSearch, {
      isLoggedIn: isLoggedIn,
      finectApp: finectApp
    }), React.createElement(IconAction, _extends({
      "data-fi-event": "omninav-secondaryMenu",
      rel: "nofollow"
    }, finectApp === 'front-questions' ? {
      as: Link,
      to: "/preguntas/nueva-pregunta"
    } : {
      href: "/preguntas",
      as: 'a'
    }, {
      $hideTablet: true,
      $hideMobile: true,
      opened: "true"
    }), React.createElement(HelpCircle, {
      color: "#fff",
      strokeWidth: "1.8",
      size: "20"
    }), React.createElement(IconActionText, null, "Pregunta en Finect")), React.createElement(Flex, null, React.createElement(Separator, null), user && isLoggedIn ? React.createElement(Fragment, null, React.createElement(IconAction, _extends({
      title: "Ver tus productos favoritos",
      "data-fi-event": "omninav-secondaryMenu"
    }, finectApp === 'front-products' ? {
      as: Link,
      to: '/tus-favoritos'
    } : {
      as: 'a',
      href: '/tus-favoritos'
    }), React.createElement(Heart, {
      color: "#fff",
      strokeWidth: "1.8",
      size: "20"
    }))) : null, user && isLoggedIn ? React.createElement(Fragment, null, React.createElement(UserAction, {
      finectApp: finectApp,
      opened: "true",
      user: user,
      toggleMobileMenu: this.toggleMobileMenu
    })) : null, user && !isLoggedIn ? React.createElement(Fragment, null, React.createElement(AccessButton, {
      rel: "nofollow",
      href: loginUrl,
      "data-fi-event": "omninav-register",
      isRegister: true,
      small: true
    }, "Identif\xEDcate")) : null))), React.createElement(LinksBar, null, React.createElement(Flex, {
      align: "left",
      as: "ul"
    }, menu.map((item, index) => React.createElement(TextMenu, _extends({
      key: index,
      finectApp: finectApp,
      app: item.app,
      text: item.title
    }, item.link ? {
      href: item.link
    } : {}, item.hasOwnProperty('children') ? {
      onAction: this.toggleNavMenu
    } : {}))))), React.createElement(Portal, {
      show: this.state.showPortal,
      finectApp: finectApp,
      productFamilies: productFamilies || [],
      links: newFamiliesLinks || [],
      banks: banks || [],
      storefronts: tags || [],
      clearTimeOut: () => {},
      closeTopic: this.debouncedTogglePortal
    })), user && showMobileNav && React.createElement(MobileMenu, {
      finectApp: finectApp,
      menuRef: el => this.target = el,
      user: user,
      toggleMobileMenu: this.toggleMobileMenu
    }));
  }
}
_defineProperty(OmniNav, "defaultProps", {
  finectApp: ''
});